import jsPDF from 'jspdf';
import 'jspdf-autotable';
import HTTPRequest from '../../../controllers/httpRequest.js';
import secureStorage from '../../../controllers/secureStorage.js';
import moment from 'moment';
import { mapState } from 'vuex';
import { decrypt } from "../../../utilities.js"

var printOthsinPiml = {
    computed: {
        ...mapState(['profileId']),
    },
    methods: {
        async printOTHSINPIML(isDefaultPrint, customFont) {
            this.spinning = true;

            let tabulatorInstance = this.$refs.tabulator.getInstance();
            let tableData = tabulatorInstance.getData();
            let documentDetails = this.documentDetails;

            const doc = new jsPDF('p', 'pt', 'a4'); 
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const documentDate = moment(documentDetails.created_at);
            const targetDate = moment(documentDetails.target_date);
            const postingDate = moment(documentDetails.posted_at);

            let xLeftKey = 35;
            let xRightKey = 560;
            let requestingSiteId = this.documentDetails.site_id.key;

            let siteData = await HTTPRequest.getRequest(`${this.endPoint}sites/${requestingSiteId}`, null, null);
            let companyData = await HTTPRequest.getRequest(`${this.endPoint}companies/${siteData.company_id}`, null, null);
            // let customer = await HTTPRequest.getRequest(`${this.endPoint}customers/${this.customer.key}`, null, null);
            let b2b = await HTTPRequest.getRequest(`${this.endPoint}b2b_customers/${this.b2bCustomer}`, null, null);
            var documentHistory = await HTTPRequest.getRequest(this.endPoint + "document_action_histories/"+documentDetails.id+"?field_name=document_id", null);

            let street_or_province = b2b.province_name || "";
            let address = b2b.address || "";
            let barangay = b2b.barangay_name || "";
            let city = b2b.city_name || "";
            let zip_code = b2b.zip_code || "";
            let isPrinted = false;
            let customerName = handleNull(b2b.name) || "No Customer Name";
            let customerCode = handleNull(b2b.code) || "No Customer Code";
            let customerTin = handleNull(b2b.tin) || "No Customer Tin";

            let b2b_payment_term = await HTTPRequest.getRequest(`${this.endPoint}payment_terms/${b2b.payment_term || 0}`, null, null);
            let payment_term_days = Number(b2b_payment_term.days)
            let dueDate = postingDate.clone().add(payment_term_days, 'days');
            let formattedCustomerAddress = `${address}, ${barangay}, ${street_or_province}, ${city} ${zip_code}`;
            // Check if any action in documentHistory is "Print Document"
            for (let i = 0; i < documentHistory.length; i++) {
                if (documentHistory[i].action === "Print Document") {
                    isPrinted = true;
                    break;
                }
            }

            function addHeader(doc, companyData, documentDetails, xLeftKey, xRightKey, pageWidth, pageNumber, pageCount) {
                doc.setFontSize(8);
                doc.text(`${decrypt(customerName)}`, xLeftKey, 60);

                // left content
                doc.setFontSize(8);
                doc.setFontStyle("normal");
                let customerAddress = doc.splitTextToSize(`${formattedCustomerAddress.toUpperCase()}`, 220)
                let companyAddress = doc.splitTextToSize(`${companyData.address || ''}`, 220);
                doc.text(customerAddress, xLeftKey, 75);
                // doc.text(`VAT REG TIN: ${companyData.tin || ''}`, xLeftKey, 60);
                // doc.text(`TEL. NO.: ${companyData.telephone || ''} FAX NO.: ${companyData.fax || ''}`, xLeftKey, 70);

                // right Content
                doc.setFontSize(8);
                doc.setFontStyle("normal");
                // doc.text(`Page ${pageNumber}/${pageCount}`, xRightKey, 30, { align: 'right' });
                doc.setFontSize(12);
                doc.setFontStyle("bold");
                doc.text('SALES - INVOICE', xRightKey, 30, { align: 'right' });
                doc.setFontSize(8);
                doc.setFontStyle("normal");
                doc.text(companyData.name, xRightKey, 60, { align: 'right' });

                let yOffset = 75; // Starting position for the first line
                companyAddress.forEach(line => {
                    doc.text(line, xRightKey, yOffset, { align: 'right' });
                    yOffset += 10; // Adjust the vertical position for the next line
                });                
            }

            // generate the first serial number from the prefix
            function generateFirstSerialNumber(casNo) {
                // split the cas_no to extract the prefix and current serial number
                const parts = casNo.split("-");
                const prefix = parts.slice(0, -1).join("-");
                const firstSerialNumber = `${prefix}-00000001`;
                return firstSerialNumber;
            }

            const currentSerialNumber = handleNull(documentDetails.cas_no);
            const firstSerialNumber = generateFirstSerialNumber(currentSerialNumber);

            function addFooter(doc, pageWidth, pageHeight) {
                const currentDate = moment().format('MM/DD/YYYY');
                const currentTime = moment().format('HH:mm');
                var userName = secureStorage.getItem("userName");

                doc.setFontSize(8);
                doc.setFontStyle("normal");
                doc.text(`Acknowledgement Certificate: ${handleNull(companyData.cas_permit_number)}`, 40, pageHeight - 50);
                doc.text(`Date Issued: ${moment(companyData.acknowledgement_receipt_date_issue).format('MM/DD/YYYY')}`, 40, pageHeight - 35);
                //doc.text(`Serial Number Range: ${handleNull(companyData.series_number_range)}`, 40, pageHeight - 20);
                doc.text(`Serial Number Range: ${'SI' + '-' + documentDetails.company_code + '-' +  companyData.series_number_range.split('-')[0] + ' - ' + 'SI' + '-' + documentDetails.company_code + '-' +  companyData.series_number_range.split('-')[1]}`, 40, pageHeight - 20);
                //doc.text(`Date Issued: ${moment().format('MM/DD/YYYY')}`, 40, pageHeight - 35);
                //doc.text(`Serial Number Range: ${firstSerialNumber} - ${currentSerialNumber}`, 40, pageHeight - 20);
                doc.text(`${documentDetails.status}`, pageWidth - 40, pageHeight - 50, { align: 'right' });
                doc.text(`${userName}`, pageWidth - 40, pageHeight - 35, { align: 'right' });
                doc.text(`${currentDate} ${currentTime}`, pageWidth - 40, pageHeight - 20, { align: 'right' });
            }

            function addSpecialFooterText(doc, pageWidth, pageHeight) {
                doc.setFontSize(7.5);
                doc.setFontStyle("bolditalic");
                doc.text('"THIS DOCUMENT IS NOT VALID FOR CLAIM OF INPUT TAX"', pageWidth / 2, pageHeight - 80, { align: 'center' });
            }

            function handleNull(value) {
                return value == null ? '' : value;
            }

            addHeader(doc, companyData, documentDetails, xLeftKey, xRightKey, pageWidth, 1, 1);

            // company info left
            const leftInfoTitleX = 35;
            const leftInfoContentX = 115;
            const leftInfoTextWidth = 150;
            const lineSpacingLeftSide = 27;
            const leftInfoY = 80 + 3 * lineSpacingLeftSide
            const leftInfoContentX2 = 150

            doc.setFontSize(8);
           
            //doc.text('Customer:', leftInfoTitleX, 100);
            //doc.text('Contact:', leftInfoTitleX, 100 + lineSpacingLeftSide);
            //doc.text('Address:', leftInfoTitleX, 100 + 2 * lineSpacingLeftSide);
            // doc.text('Business Style:', leftInfoTitleX, 100 + 3 * lineSpacingLeftSide);
            // doc.text('TIN:', leftInfoTitleX, 100 + 4 * lineSpacingLeftSide);

            doc.setFontStyle("normal");
            // let customerName = handleNull(customer.name) || handleNull(b2b.name) || "No Customer Name";
            // let customerMobileNo = handleNull(customer.mobile) || handleNull(b2b.mobile)            //doc.text(handleNull(customer.mobile) || handleNull(b2b.mobile), leftInfoContentX, 100 + lineSpacingLeftSide);
            // let customerAddress = handleNull(formattedCustomerAddress) || "No Customer Address";
            //let deliveredTo = doc.splitTextToSize(customerName, leftInfoTextWidth);
            //doc.text(deliveredTo, leftInfoContentX, 100);
            //let address = doc.splitTextToSize(customerAddress, leftInfoTextWidth);
            //doc.text(address, leftInfoContentX, 100 + 2 * lineSpacingLeftSide);
            // let businessStyle = doc.splitTextToSize(handleNull(customer.business_style_name) || handleNull(b2b.business_style_name), leftInfoTextWidth);
            // doc.text(businessStyle, leftInfoContentX, 100 + 3 * lineSpacingLeftSide);
            // doc.text(handleNull(customer.tin) || handleNull(b2b.tin), leftInfoContentX, 100 + 4 * lineSpacingLeftSide);
            doc.setLineHeightFactor(1.5);
            doc.text('Bill-to Customer No.', leftInfoTitleX, 115);
            doc.text('VAT Registration No.', leftInfoTitleX, 130);
            doc.text('SI No.', leftInfoTitleX, 145);  
            
            doc.setLineHeightFactor(1.5);
            doc.text(customerCode || '', leftInfoContentX2, 115);
            doc.text(decrypt(customerTin) || '', leftInfoContentX2, 130);
            //doc.text(documentDetails.cas_no || '', leftInfoContentX2, 145); 
            doc.text((documentDetails.code_and_document_no || ''),leftInfoContentX2, 145);

            // company info right
            const rightInfoX = 340;
            const rightInfoContentX = rightInfoX + 95;
            const lineSpacingRightSide = 15;

            //doc.text('Bill-to Customer No:', rightInfoX, 100);
            doc.text('Posting Date', leftInfoTitleX, leftInfoY);
            doc.text('Due Date', leftInfoTitleX, leftInfoY + 12);
            doc.text('Document Date', leftInfoTitleX, leftInfoY + 24);
            doc.text('Payment Terms', leftInfoTitleX, leftInfoY + 36);

            doc.text('Shipment Method', leftInfoTitleX, leftInfoY + 48);
            doc.text('Prices Including VAT', leftInfoTitleX, leftInfoY + 60);
            //doc.text('Order No.:', leftInfoTitleX, leftInfoY + 96);
            //doc.text('Country of Origin:', rightInfoX, 100 + 6 * lineSpacingRightSide);

            //doc.text('External Document No.:', rightInfoX, 100 + 7 * lineSpacingRightSide);
            //doc.text('Commercial Invoice:', leftInfoTitleX, leftInfoY + 108);
            //doc.text('Country of Origin:', rightInfoX, 100 + 8 * lineSpacingRightSide);
            doc.text('Brand Name', leftInfoTitleX, leftInfoY + 72);
            doc.text('Season', leftInfoTitleX, leftInfoY + 84);
            doc.text('SOX REF', leftInfoTitleX, leftInfoY + 96);
            doc.text('Carton Count', leftInfoTitleX, leftInfoY + 108);

            doc.setFontStyle("normal");
            doc.text(handleNull(postingDate.format('MM/DD/YYYY')), leftInfoContentX2, leftInfoY);
            doc.text(handleNull(dueDate.format('MM/DD/YYYY')), leftInfoContentX2, leftInfoY + 12)
            doc.text(handleNull(documentDate.format('MMMM DD, YYYY')), leftInfoContentX2, leftInfoY + 24);
            
            //doc.text(handleNull(""), rightInfoContentX, 100); // note: bill-to customer no., to be check w/ primer
            doc.text(handleNull(documentDetails.payment_term_name), leftInfoContentX2, leftInfoY+36);
            doc.text(handleNull(documentDetails.shipping_method_name), leftInfoContentX2, leftInfoY + 48);
            doc.text(handleNull(documentDetails.is_prices_including_vat), leftInfoContentX2, leftInfoY + 60);
            //doc.text(handleNull(documentDetails.oc_ref_no), leftInfoContentX2, leftInfoY + 60);
            //doc.text(handleNull(documentDetails.cas_no), leftInfoContentX2, leftInfoY + 96);
            //doc.text(handleNull(documentDetails.country_id.label), rightInfoContentX, 100 + 6 * lineSpacingRightSide);
            //doc.text(handleNull(documentDetails.code_and_document_no), rightInfoContentX, 100 + 7 * lineSpacingRightSide);
            //doc.text(handleNull(""), leftInfoContentX2, leftInfoY + 108 ); // note: commercial invoice, to be check w/ primer
            //doc.text(handleNull(documentDetails.remark), leftInfoContentX2, leftInfoY + 96);
            doc.text(documentDetails.brand_names, leftInfoContentX2, leftInfoY + 72)
            doc.text(documentDetails.year_season, leftInfoContentX2, leftInfoY + 84);
            doc.text(documentDetails.si_sox_ref_no.label || '', leftInfoContentX2, leftInfoY + 96);
            doc.text(documentDetails.no_of_cartons || '', leftInfoContentX2, leftInfoY + 108);

            doc.text('Phone No.', rightInfoX, 115);
            doc.text('E-Mail', rightInfoX, 130);
            doc.text('Home Page', rightInfoX, 145);
            doc.text('VAT Reg. No.', rightInfoX, 160);
            doc.text('Giro No.', rightInfoX, 175);
            doc.text('Bank', rightInfoX, 190);
            doc.text('Account No.', rightInfoX, 205);
            doc.text('Customer PO no.', rightInfoX, 220);
            doc.text('PIML PO no.', rightInfoX, 235);
            doc.text('Country of Origin', rightInfoX, 250);      
            doc.text('SHIPMENT PN', rightInfoX, 265);

            doc.text(decrypt(b2b.telephone) || '', rightInfoContentX, 115);
            doc.text(decrypt(b2b.email) || '', rightInfoContentX, 130);
            doc.text('', rightInfoContentX, 145);
            doc.text(companyData.tin || '', rightInfoContentX, 160);
            doc.text('', rightInfoContentX, 175);
            doc.text('', rightInfoContentX, 190);
            doc.text('', rightInfoContentX, 205);
            doc.text(documentDetails.reference_1, rightInfoContentX, 220);
            doc.text(documentDetails.reference_2, rightInfoContentX, 235);
            doc.text(documentDetails.country_id.label || '', rightInfoContentX, 250);
            const shipmentRefLines = doc.splitTextToSize(documentDetails.shipment_ref_no || '', 132);
            shipmentRefLines.forEach((line, index) => {
                doc.text(line, rightInfoContentX, 265 + (index * 10));
            });

            // table data
            const tableColumn = [
                { header: 'Vendor Item No.', dataKey: 'vendor_item_no', styles: { halign: 'left' } },
                { header: 'Style Name', dataKey: 'style_name', styles: { halign: 'left' } },
                { header: 'Barcode.', dataKey: 'barcode', styles: { halign: 'right' } },
                { header: 'QTY', dataKey: 'quantity', styles: { halign: 'right' } },
                { header: 'Unit of Measure', dataKey: 'unit_name', styles: { halign: 'left' } },
                { header: 'Size', dataKey: 'size', styles: { halign: 'left' } },
                { header: 'Color', dataKey: 'color', styles: { halign: 'left' } },
                { header: 'Cur', dataKey: 'currency', styles: { halign: 'left' } },
                { header: 'Unit Price', dataKey: 'price', styles: { halign: 'right' } },
                { header: 'Line Discount', dataKey: 'discount', styles: { halign: 'right' } },
                { header: 'Amount', dataKey: 'subtotal', styles: { halign: 'right' } },
            ];

            function extractValues(data, keys) {
                return data.map(row => {
                    const newRow = {};
                    keys.forEach(column => {
                        if (row.hasOwnProperty(column.dataKey)) {
                            if (column.dataKey === 'price') {
                                // format amount of money w/ commas and w/ 2 decimal places
                                newRow[column.dataKey] = parseFloat(row[column.dataKey]).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                });
                            } else if (column.dataKey === 'discount') {
                                // format amount of money w/ commas and w/ 2 decimal places
                                newRow[column.dataKey] = parseFloat(row[column.dataKey]).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                });
                            } else if (column.dataKey === 'subtotal') {
                                // format amount of money w/ commas and w/ 2 decimal places
                                newRow[column.dataKey] = parseFloat(row[column.dataKey]).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                });
                            } else if (column.dataKey === 'quantity') {
                                // format quantity as a whole number
                                newRow[column.dataKey] = Math.round(parseFloat(row[column.dataKey]));
                            } else if (column.dataKey === 'style_name') {
                                if (row[column.dataKey] == null) {
                                    newRow[column.dataKey] = '-';
                                } else {
                                    newRow[column.dataKey] = row[column.dataKey];
                                }
                            } else {
                                newRow[column.dataKey] = row[column.dataKey];
                            }
                        }
                    });
                    return newRow;
                });
            }

            const extractedData = extractValues(tableData, tableColumn);

            // calculate totals
            let totalQuantity = 0;
            let totalPrice = 0;
            let formattedTotalPrice = 0;
            extractedData.forEach(row => {
                totalQuantity += parseFloat(row.quantity);
                totalPrice += parseFloat(row.subtotal);
                if (typeof row.subtotal === 'string') {
                    // remove commas before summing the values
                    formattedTotalPrice += parseFloat(row.subtotal.replace(/,/g, ''));
                } else {
                    formattedTotalPrice += parseFloat(row.subtotal);
                }
            });

            const formattedTotalPriceString = formattedTotalPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            // footer row
            const footerRow = [
                { content: '', colSpan: 1 },
                { content: 'Total Quantity', colSpan: 2, styles: { halign: 'right' } },
                { content: totalQuantity.toLocaleString(), colSpan: 1, styles: { halign: 'right' } },
                { content: '', colSpan: 4 },
                { content: 'Total USD', colSpan: 2, styles: { halign: 'right' } },
                { content: formattedTotalPriceString, colSpan: 1, styles: { halign: 'right' } },
            ];

            const headerDiscountRow = [
                { content: '', colSpan: 2 },
                { content: '', colSpan: 1, styles: { halign: ''  } },
                { content: '', colSpan: 1, styles: { halign: 'right' } },
                { content: '', colSpan: 4 },
                { content: 'Discount USD', colSpan: 2, styles: { halign: 'right', fontStyle: 'normal' } },
                { content: parseFloat(documentDetails.amount_header_discount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }), colSpan: 1, styles: { halign: 'right', fontStyle: 'normal' } },
            ];

            const totalPhpRow = [
                { content: '', colSpan: 2 },
                { content: '', colSpan: 1, styles: { halign: ''  } },
                { content: '', colSpan: 1, styles: { halign: 'right' } },
                { content: '', colSpan: 4 },
                { content: 'Net Amount USD', colSpan: 2, styles: { halign: 'right' } },
                { content: parseFloat(documentDetails.amount_net).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }), colSpan: 1, styles: { halign: 'right', undeline: 'single' } },
            ];

            // not a fixed table, item lists are dynamic
            const baseTableOptions = {
                theme: 'grid',
                startY: 280,
                styles: { fontSize: 8 },
                margin: { top: 125, bottom: 100, left: 30, right: 30 }, // increased top margin
                pageBreak: 'auto',
                headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center',lineWidth: 0.5, lineColor: [0, 0, 0]},
                bodyStyles: { halign: 'center',lineWidth: 0.5, lineColor: [0, 0, 0] },
                columnStyles: {
                    vendor_item_no: { cellWidth: 50 },
                    product_name: { cellWidth: 50, halign: 'left'},
                    barcode: { cellWidth: 50 },
                    quantity: { cellWidth: 190 },
                    unit_name: { cellWidth: 65 },
                    price: { cellWidth: 65 },
                    size: { cellWidth: 65 },
                    color: { cellWidth: 65 },
                    subtotal: { cellWidth: 65 },
                },
                
                didDrawPage: function (data) {
                    if (data.pageNumber > 1) {
                        addHeader(doc, companyData, documentDetails, xLeftKey, xRightKey, pageWidth, data.pageNumber, data.pageCount);
                    }

                    if (data.pageNumber === data.pageCount) {
                        addSpecialFooterText(doc, pageWidth, pageHeight);
                    }

                    addFooter(doc, pageWidth, pageHeight);
                },
                head: [tableColumn.map(column => column.header)],
                body: extractedData.map(row => {
                    return tableColumn.map(column => {
                        return {
                            content: row[column.dataKey],
                            styles: { halign: column.styles.halign } // include the alignment style for each cell
                        };
                    });
                }),
                showFoot: 'lastPage',
                footStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center' },
            };

            function renderTableParts(doc, data, options) {
                let currentIndex = 0;
                const totalRows = data.length;

                while (currentIndex < totalRows) {
                    const isFirstPart = currentIndex === 0;
                    const currentStartY = isFirstPart ? options.startY : 125;

                    // calculate available space dynamically for each page
                    const footerHeight = 100;
                    const pageHeight = doc.internal.pageSize.height;
                    const availableHeight = pageHeight - currentStartY - footerHeight;

                    // estimation based on actual available space
                    const estimatedRowHeight = 10;
                    const maxRowsForThisPage = Math.floor(availableHeight / estimatedRowHeight);

                    const remainingRows = totalRows - currentIndex;
                    const rowsToRender = Math.min(remainingRows, maxRowsForThisPage);

                    // extract the current part of the data to render
                    const currentPart = data.slice(currentIndex, currentIndex + rowsToRender);

                    // update table options for the current part
                    options.body = currentPart.map(row => tableColumn.map(column => ({
                        content: row[column.dataKey],
                        styles: { halign: column.styles.halign }
                    })));

                    // check if this is the last part to render
                    const isLastChunk = currentIndex + rowsToRender >= totalRows;

                    // estimate height of foot rows
                    const estimatedFootHeight = 45;

                    // if it’s the last chunk AND there’s room for footer
                    if (isLastChunk && (availableHeight - (rowsToRender * estimatedRowHeight) > estimatedFootHeight)) {
                        options.foot = [footerRow, headerDiscountRow, totalPhpRow];
                        options.showFoot = 'lastPage';
                    } else {
                        options.foot = [];
                    }

                    // if (currentIndex + rowsToRender >= totalRows) {
                    //     options.foot = [footerRow, headerDiscountRow, totalPhpRow];
                    //     options.showFoot = 'lastPage';
                    //     options.footStyles = { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center' };
                    // } else {
                    //     options.foot = [];
                    // } 

                    options.didDrawCell = function (data) {
                        const { row, column, cell, doc, section} = data;
                        if(section === 'foot'){
                            if (cell.styles.undeline === 'single') {
                                const cellHeight = cell.height; 
                                const cellX = cell.x;
                                const cellY = cell.y + cellHeight;

                                doc.setLineWidth(0.5);
                                doc.setDrawColor(0, 0, 0);
                                doc.line(cellX, cellY - 18, cellX + cell.width, cellY - 18);
                            }
                        }
                    };

                    // set proper startY for each page part
                    options.startY = currentStartY;

                    // render the current part
                    doc.autoTable(options);
                    
                    // get actual table end position for better space calculation
                    const tableEndY = doc.lastAutoTable.finalY;
                    const spaceLeft = pageHeight - tableEndY - footerHeight;

                    // move to the next part
                    currentIndex += rowsToRender;

                    // add a new page if there are more rows to render
                    if (currentIndex < totalRows) {
                        // only add new page if we actually need it
                        if (spaceLeft < 30) {
                            doc.addPage();
                            addHeader(doc, companyData, documentDetails, xLeftKey, xRightKey, pageWidth, doc.internal.getNumberOfPages(), doc.internal.getNumberOfPages());
                        }
                    }
                }
            }

            // render the table dynamically
            renderTableParts(doc, extractedData, baseTableOptions);

            for(var i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.text('PAGE ' + i + '/' + pageCount, xRightKey, 45, { align: 'right' });
            }

            const pageCount = doc.internal.getNumberOfPages();
            for(var i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.text('PAGE ' + i + '/' + pageCount, xRightKey, 45, { align: 'right' });
            }
            this.spinning = false
            //doc.save(`CAS-${handleNull(documentDetails.cas_no)}.pdf`);
            let pdfWindow = window.open(doc.output('bloburl'), '_blank');
            // Add manual print trigger button
            const detectBrowser = () => {
                const agent = window.navigator.userAgent.toLowerCase();
                if (agent.indexOf('edg') > -1) return 'Microsoft Edge';
                if (agent.indexOf('chrome') > -1) return 'Google Chrome';
                if (agent.indexOf('safari') > -1) return 'Safari';
                return 'Not Supported Browser';
            };
        
            const detectColorScheme = () => {
                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    return 'dark';
                }
                return 'light';
            };
        
            const browserName = detectBrowser();
            const colorScheme = detectColorScheme();
            const browserColors = {
                'Google Chrome': {
                    dark: 'rgb(51, 54, 57)',
                    light: 'white'
                },
                'Microsoft Edge': {
                    dark: 'rgb(59, 59, 59)',
                    light: 'rgb(247, 247, 247)'
                },
                'Safari': {
                    dark: 'rgb(44, 44, 44)',
                    light: 'white'
                },
                'default': {
                    dark: 'rgb(30, 33, 36)',
                    light: 'white'
                }
            };
            const getBackgroundColor = () => {
                const browserColorConfig = browserColors[browserName] || browserColors['default'];
                return browserColorConfig[colorScheme];
            };
            
            if (!isPrinted){
                pdfWindow.addEventListener('load', () => {
                    const printButton = pdfWindow.document.createElement('button');
                    printButton.style.position = 'fixed';
                    printButton.style.top = browserName == 'Microsoft Edge' ? '2px' : '10px';
                    printButton.style.right = '10px';
                    printButton.style.zIndex = '9999';
                    printButton.style.marginRight = '44px';
                    printButton.style.backgroundColor = getBackgroundColor();
                    printButton.style.border = 'none'; 
                    printButton.style.padding = browserName == 'Microsoft Edge' ? '10px 40px': '10px 20px'; 
                    printButton.style.cursor = 'pointer';
                    printButton.style.color = colorScheme == 'dark'? 'white' : 'black'
                    printButton.style.fontSize = '15px'
    
                    const fontAwesomeLink = pdfWindow.document.createElement('link');
                    fontAwesomeLink.rel = 'stylesheet';
                    fontAwesomeLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
                    pdfWindow.document.head.appendChild(fontAwesomeLink);
                
                    printButton.innerHTML = '<i class="fas fa-print"></i> Print';
                    
                    printButton.addEventListener('click', () => {
                        pdfWindow.print()
                        this.create_action_history('Print Document', documentDetails.id)
                    });
                    pdfWindow.document.body.appendChild(printButton);
                });
            }
        },
        async create_action_history(action,doc_no) {
            var actionHistoryPayload = {
                action: action,
                action_at: moment(new Date()),
                action_by: secureStorage.getItem("userName"),
                document_id: doc_no,
                status: "A"
            }
            await HTTPRequest.postRequest(this.endPoint + 'document_action_histories/', null, actionHistoryPayload)
        },
    },
};

export default printOthsinPiml;
